import remarkGfm from 'remark-gfm'

import { GretaAIChatMarkdownLink } from '../GretaAIChatMarkdownLink'
import { GretaAIChatMarkdownPre } from '../GretaAIChatMarkdownPre'
import { GretaAIChatMarkdownTable } from '../GretaAIChatMarkdownTable'

export const GRETA_AI_CHAT_MARKDOWN_PLUGINS = [remarkGfm]

export const GRETA_AI_CHAT_MARKDOWN_COMPONENTS = {
  a: GretaAIChatMarkdownLink,
  pre: GretaAIChatMarkdownPre,
  table: GretaAIChatMarkdownTable,
}
